import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import appConfig from '../app.config';
import { authStorageService, localStorageService } from '../services/service-factory';
import i18next from 'i18next';
import { LICENSE_MODULES, ACCESS_TO_REPORTS, ROLES } from '../../../../constants';

Vue.use(Router);

const license = localStorageService.get('license');

let filteredRoutes = routes;
if (license) {
  filteredRoutes = routes.filter((r) => {
    if (r.meta && (r.meta.module || r.meta.modules)) {
      let modules = [...license.modules];
      const isReportPart = ACCESS_TO_REPORTS.some((m) => modules.includes(m));
      if (isReportPart) {
        modules.push(LICENSE_MODULES.IS_REPORTS_PART);
      }

      let modulesArray = null;
      if (r.meta.modules) {
        modulesArray = modules.filter((value) => r.meta.modules.includes(value));
      }
      if (!license || !modules) {
        return true;
      }

      if (modules.includes(r.meta.module) || (modulesArray && modulesArray.length)) {
        return true;
      }
      return false;
    }
    return true;
  });
}

const router = new Router({
  mode: 'history',
  routes: filteredRoutes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isAuthRequired = to.matched.some((route) => route.meta.requiresAuth);

  if (!isAuthRequired) {
    return next();
  }

  if (to.meta.module || to.meta.modules) {
    const license = localStorageService.get('license');

    if (!license) {
      return next({
        name: 'sign-in',
      });
    }

    let modules = [...license.modules];
    const isReportPart = ACCESS_TO_REPORTS.some((m) => modules.includes(m));
    if (isReportPart) {
      modules.push(LICENSE_MODULES.IS_REPORTS_PART);
    }

    let modulesArray = null;
    if (to.meta.modules) {
      modulesArray = modules.filter((value) => to.meta.modules.includes(value));
    }

    if (!license || !modules || !(modules.includes(to.meta.module) || (modulesArray && modulesArray.length))) {
      return next({
        name: 'not-found',
      });
    }
  }

  let role = '';

  try {
    role = authStorageService.getAuth().role;
  } catch (e) {
    console.log('No role');
  }

  if (isAuthRequired && !authStorageService.isAuthenticated()) {
    window.location.replace('/');
    localStorage.clear();
    return;
  } else if (isAuthRequired && !to.matched.every((route) => route.meta.roles === '*' || route.meta.roles.includes(role))) {
    if (to.meta.module === LICENSE_MODULES.AVG || (to.meta.modules && to.meta.modules.includes(LICENSE_MODULES.AVG))) {
      const home = role === ROLES.REPORTUSER ? 'monthly-values' : 'home-avg';

      return next({
        name: home,
      });
    }
    return next({
      name: 'home',
    });
  } else {
    return next();
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    if (to.meta && to.meta.title) {
      to.meta.title = i18next.t(to.meta.title);
    }
    document.title = to.meta && to.meta.title ? `${appConfig.appName} - ${to.meta.title}` : appConfig.appName;
  });
});

export default router;
